import script from "./PortaFolio.vue?vue&type=script&setup=true&lang=js"
export * from "./PortaFolio.vue?vue&type=script&setup=true&lang=js"

import "./PortaFolio.vue?vue&type=style&index=0&id=18cc1ddd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18cc1ddd"]])

export default __exports__